export const METAS = [
    { 
        rutas: ['/', '/home'],
        detalle: {
            es: {
                title: 'EnjoyCL - Home',
                description : 'Esta es la descripción del Home',
                index: 'index'
            }
        }
    },
    { 
        rutas: ['/nosotros'],
        detalle: {
            es: {
                title: 'EnjoyCL - Nosotros',
                description : 'Esta es la descripción del Home',
                index: 'index'
            },
            en: {
                title: 'EnjoyCL - About us',
                description : 'This is the description of Home',
                index: 'index'
            }
        }
    }
]